import { render } from "./pestel_step_two.vue?vue&type=template&id=a07916d4&scoped=true"
import script from "./pestel_step_two.vue?vue&type=script&lang=js"
export * from "./pestel_step_two.vue?vue&type=script&lang=js"

import "./pestel_step_two.vue?vue&type=style&index=0&id=a07916d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a07916d4"]])

export default __exports__